import { Confirmation as Interface } from './types';
import * as styles from './Confirmation.css';
import Popup from '../Popup';
import { ComponentProps, memo } from 'react';
import Button from '../Button/Button';

const Confirmation = ({ title, description, actions }: Interface.Props) => {
  return (
    <Popup>
      <div className={styles.container}>
        <div className={styles.contents}>
          {title && <Popup.Title>{title}</Popup.Title>}
          {description && <Popup.Text>{description}</Popup.Text>}
        </div>
        {actions.length && (
          <div className={styles.submit}>
            <Actions actions={actions} />
          </div>
        )}
      </div>
    </Popup>
  );
};

const Actions = memo(({ actions }: Pick<Interface.Props, 'actions'>) => {
  const makeProps = (highlight: boolean): ComponentProps<typeof Button> =>
    highlight
      ? { type: 'solid', size: 'xlarge', category: 'primary' }
      : { type: 'outline', size: 'xlarge', category: 'neutral' };

  return actions.map(({ title, highlight = false, handler }) => (
    <Button {...makeProps(highlight)} onClick={handler}>
      {title}
    </Button>
  ));
});

Actions.displayName = 'ConfirmationActions';

export default Confirmation;
